import * as Yup from 'yup';
import { RepresentativeSchema } from './representative';

const salesPeriodDays = [7, 14, 30, 60, 90, 180, 365] as const;
export type SalesPeriodDays = (typeof salesPeriodDays)[number];

export const thresholdWeeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type ThresholdWeeks = (typeof thresholdWeeks)[number];

export const reorderWeeks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type ReorderWeeks = (typeof reorderWeeks)[number];

// Dropdown options for the two week settings, shared by the order edit
// popover and the vendor defaults form. Both surfaces offer choices rather
// than a number input: these values round-trip through the API and back
// through the schemas above, and a typed-in 0 or 24 comes back rejected,
// which strands the order it was saved against.
const toWeekOptions = <T extends number>(weeks: readonly T[]) =>
  weeks.map((value) => ({ value, label: String(value) }));

export const thresholdWeekOptions = toWeekOptions(thresholdWeeks);
export const reorderWeekOptions = toWeekOptions(reorderWeeks);

// form validation rules
const OrderDefaultsSchema = Yup.object().shape({
  qoh_threshold_weeks: Yup.mixed<ThresholdWeeks>().oneOf(thresholdWeeks).defined().required(),
  reorder_weeks: Yup.mixed<ReorderWeeks>().oneOf(reorderWeeks).defined().required(),

  send_method: Yup.string().defined(),

  // sales_period_days is not settable in any UI, but the suggestion math still
  // reads it and 33 vendors carry a non-30 value — see ORD-390. Declared so it
  // keeps its type; qoh_threshold_percent is deliberately absent, see the note
  // on OrderOptionsSchema.
  sales_period_days: Yup.mixed<SalesPeriodDays>().oneOf(salesPeriodDays).defined().required(),
});

export const OrderSettingsSchema = Yup.object().shape({
  defaults: OrderDefaultsSchema.required(),

  send_methods: Yup.array().of(Yup.string().required()).required(),
  representatives: Yup.array().of(RepresentativeSchema.required()).required(),
});

export type OrderSettings = Yup.InferType<typeof OrderSettingsSchema>;
